/* eslint-disable */
import axios from 'axios';
import UserToken from '../../classes/UserToken';
import * as Sentry from '@sentry/vue';
import { getLocalStorage } from '../../utils/storage';
const localStorage = getLocalStorage();
// @todo: update urls here
export default {
  namespaced: true,
  state: {
    email: localStorage.getItem('email'),
    name: localStorage.getItem('name'),
    password: '',
    confirmPassword: '',
    birthday: '',
    avatar: '',
    authType: localStorage.getItem('authType'),
    loginType: null,
    points: 0,
    rank: '',
    voterId: localStorage.getItem('voterId'),
    externalToken: null,
    authorizationToken: localStorage.getItem('authorization_token'),
    resetToken: '',
    isAuthenticated: false,
    showAuthHeader: true, // @todo make this configurable - will be false for BBL
    view: 'poll',
    previousView: 'poll',
    formFields: ['name', 'email', 'birthday', 'password'], // @hack: should populate these based on whether email/password is enabled + custom-defined fields
    errorMessage: '',
    showTimer: false,
    timerLimit: 30,
    period: 30,
    pageLoadTime: 0,
    gamePollGroups: [],
    gamePollGroupIds: [],
    gameLogo: '',
    gamificationLinks: {},
    hashSettings: {},
    startTime: null,
    accountName: null,
    voteId: null,
    summary: {
      detial: [],
      quizPosition: 0,
      quizParticipants: 0,
      totalPosition: 0,
      totalParticipants: 0
    },
    isOptInEnabled: true,
    optInText: '',
    optIn: true,
    isPreview: false,
    authenticationMethods: {}
  },
  getters: {
    isAuthenticationEnabled: (state) => {
      return Object.entries(state.authenticationMethods)
        .filter(([key, value]) => key !== 'none')
        .some(([key, value]) => value);
    },
    facebookSignInLink(state) {
      return `${state.gamificationLinks.socialSignIn}facebook`;
    },
    googleSignInLink(state) {
      return `${state.gamificationLinks.socialSignIn}google`;
    },
    microsoftSignInLink(state) {
      return `${state.gamificationLinks.socialSignIn}microsoft`;
    },
    getSummary(state) {
      return state.summary.detail;
    },
    getCorrectAnswersCount(state) {
      return state.summary.detail.filter(x => x.correct).length;
    },
    getTotalAnswersCount(state) {
      return state.summary.detail.length;
    },
    getQuizPosition(state) {
      return state.summary.quizPosition;
    },
    getQuizParticipants(state) {
      return state.summary.quizParticipants;
    },
    getTotalPosition(state) {
      return state.summary.totalPosition;
    },
    getTotlParticipants(state) {
      return state.summary.totalParticipants;
    }
  },
  mutations: {
    setView(state, name) {
      if (!name) {
        return;
      }

      const POSSIBLE_VIEWS = ['poll', 'leaderboard', 'login', 'signup', 'correctAnswer', 'winner', 'pollGroups', 'summary', 'congratulations', 'unauthorized'];
      state.previousView = state.view;
      !state.isPreviev && (state.view = name);
    },
    setAuthorizationToken(state, token) {
      state.authorizationToken = token;
      localStorage.setItem('authorization_token', token);
    },
    setResetToken(state, token) {
      state.resetToken = token;
    },
    setVoterId(state, voterId) {
      state.voterId = voterId;
      localStorage.setItem('voterId', voterId);
      localStorage.removeItem
    },
    setName(state, name) {
      state.name = name;
      localStorage.setItem('voterName', name);
    },
    setAvatar(state, picture) {
      state.avatar = picture;
      localStorage.setItem('avatar', picture);
    },
    setEmail(state, email) {
      state.email = email;
      email ? localStorage.setItem('email', email) : localStorage.removeItem('email', email)
    },
    setPassword(state, password) {
      state.password = password;
    },
    setConfirmPassword(state, password) {
      state.confirmPassword = password;
    },
    setBirthday(state, date) {
      state.birthday = date;
    },
    setOptIn(state, optIn) {
      state.optIn = optIn;
    },
    setAuthType(state, authType) {
      state.authType = authType;
      localStorage.setItem('authType', authType);
    },
    setLoginType(state, loginType) {
      state.loginType = loginType;
    },
    setRank(state, rank) {
      state.rank = rank;
    },
    setGamify(state, gamify) {
      state.gamify = gamify;
    },
    setAuthenticationMethods(state, authMethods) {
      state.authenticationMethods = authMethods || {};
    },
    setGamePollGroups(state, pollGroups) {
      state.gamePollGroups = pollGroups;
    },
    setGamePollGroupIds(state, pollGroupIds) {
      state.gamePollGroupIds = pollGroupIds;
    },
    setGameLogo(state, gameLogo) {
      state.gameLogo = gameLogo;
    },
    setPoints(state, points) {
      state.points = points;
    },
    setAuthState(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    setIsOptInEnabled(state, isOptInEnabled) {
      state.isOptInEnabled = isOptInEnabled;
    },
    setOptInText(state, optInText) {
      state.optInText = optInText;
    },
    setRegistrationType(state, type) {
      // @todo: deprecated
      switch(type) {
        case 'minimal':
          state.formFields = ['name', 'email', 'birthday', 'password'];
          break;
        case 'nameOnly': {
          state.formFields = ['name'];
          const uuId = new UserToken().uuidv4();
          state.email = `${uuId}@excitem.tv`;
          state.password = `pass-${uuId}`;
          state.birthday = '1970-01-01';
          break;
        }
        // @todo add more options
      }
    },
    setError(state, message) {
      state.errorMessage = message;
    },
    setHashSettings(state) {
      try {
        state.hashSettings = JSON.parse(decodeURIComponent(window.location.hash.substring(1)));
      } catch(e) {
        state.hashSettings = {};
      }
    },
    setTimer(state, timerLimit) {
      state.showTimer = true;
      state.timerLimit = timerLimit || 30;
    },
    setStartTime(state, date) {
      state.startTime = date;
    },
    setPeriod(state, period) {
      state.period = period || 30;
    },
    setExternalToken(state, token) {
      state.externalToken = token;
    },
    setGamificationLinks(state, gamificationLinks) {
      state.gamificationLinks = gamificationLinks;
    },
    setAccountName(state, accountName) {
      state.accountName = accountName;
    },
    setVoteId(state, voteId) {
      state.voteId = voteId;
    },
    setSummary(state, summary) {
      state.summary = summary;
    },
    setIsPreview(state, isPreview) {
      state.isPreview = !!isPreview;
    }
  },
  actions: {
    switchView({ commit }, viewName) {
      console.log('switchView', viewName);
      commit('setView', viewName);
    },
    setEJSVariables({ commit }, data) {
      console.log('setEJSVariables', data);
      commit('setGamificationLinks', data.gamificationLinks);
      commit('setAccountName', data.accountName);
      commit('setIsPreview', data.isPreview);
      //commit('setSkipAuthentication', data.authenticationMethods);
      // commit('setGameAuthMethods', data.authenticationMethods);
      commit('setAuthenticationMethods', data.authenticationMethods.gamingAuthMethods);
    },
    setTimeLimit({ commit }, period) {
      commit('setTimer', period);
      commit('setPeriod', period);
    },
    initAuthorizedState({state, commit, dispatch}, {
      authorizationToken,
      voterId,
      loginType,
      name
    }) {
      const path = window.location.pathname.replace('/play', '/');
      let [, view, identifier, , pollGroupId] = path.split('/');

      commit('setAccountName', identifier);

      if (pollGroupId) {
        commit('poll/setPollGroupId', pollGroupId, { root: true });
      }

      console.log('initAuthorizedState: state.hashSettings', state.hashSettings.view);
      commit('setAuthorizationToken', authorizationToken);
      commit('setVoterId', voterId);
      commit('setAuthType', 'email');
      commit('setLoginType', loginType);
      commit('setName', name);
      commit('setAuthState', !!voterId);
    },
    async loginVeevUser({ state, commit, dispatch }) {
      const params = new URLSearchParams(window.location.search);
      const query = params.get('query') || '';
      if (!query) {
        throw new Error('Missing parameters');
      }
      //const query = location.search.substr(location.search.indexOf('query=') + 6, queryParam.length);
      const {
        data: {
          body
        }
      } = await axios.post(`${state.gamificationLinks.veevSignIn}/veev`, { query });

      const {
        authorization_token: authorizationToken,
        id: voterId,
        errorMessage
      } = JSON.parse(body);
      if (errorMessage) {
        commit('setError', errorMessage);
        throw new Error(state.errorMessage);
      }
      if (!authorizationToken) {
        return commit('setView', 'signup');
      }

      dispatch('initAuthorizedState', {
        authorizationToken,
        voterId,
        name: ''
      });
    },
    async loginByToken({ state, commit, dispatch, rootState }) {
      try {
        if (!state.externalToken) {
          return commit('setView', 'unauthorized');
        }

        const {
          data: {
            body
          }
        } = await axios.post(`${state.gamificationLinks.voterSignIn}/token`, {}, {
          headers: {
            Authorization: `Bearer ${state.externalToken}`
          }
        });
        const {
          authorization_token: authorizationToken,
          id: voterId,
          loginType,
          errorMessage
        } = JSON.parse(body);
        if (errorMessage) {
          commit('setError', errorMessage);
          throw new Error(state.errorMessage);
        }
        if (!authorizationToken) {
          return commit('setView', 'unauthorized');
        }

        dispatch('initAuthorizedState', {
          authorizationToken,
          voterId,
          loginType,
          name: ''
        });
      } catch (e) {
        throw new Error(e);
      }
    },
    async signin({ state, commit, rootState, dispatch }, {
      email,
      password,
      accountName,
      optIn
    }) {
      try {
        const {
          data: {
            authorization_token: authorizationToken,
            id: voterId,
            errorMessage
          }
        } = await axios.post(state.gamificationLinks.voterSignIn, {
          email,
          password,
          accountName,
          optIn
        });
        if (errorMessage) {
          commit('setError', errorMessage);
          throw new Error(state.errorMessage);
        }
        dispatch('initAuthorizedState', {
          authorizationToken,
          voterId,
          name: ''
        });
        //Clear votes from previus voter
        localStorage.removeItem('playToken');
        localStorage.removeItem('revisions');
        await dispatch('getVoterData', accountName);
      } catch (e) {
        Sentry.captureException(e);
        throw new Error(e);
      }
    },
    async forgotPassword({ state, commit, rootState, dispatch }, {
      email,
      accountName
    }) {
      try {
        const { data } = await axios.post(state.gamificationLinks.forgotPassword, {
          email,
          accountName
        });
        if ((data || {}).errorMessage) {
          commit('setError', data.errorMessage);
          throw new Error(state.errorMessage);
        }
      } catch (e) {
        Sentry.captureException(e);
        throw new Error(e);
      }
    },
    async resetPassword({ state, commit, rootState, dispatch }, {
      password,
      token
    }) {
      try {
        const {
          data: {
            errorMessage
          }
        } = await axios.put(state.gamificationLinks.resetPassword, {
          password,
          token
        });
        if (errorMessage) {
          commit('setError', errorMessage);
          throw new Error(state.errorMessage);
        }
      } catch (e) {
        Sentry.captureException(e);
        throw new Error(e);
      }
    },
    async checkWhitelistAccess({ state }, pollId) {
      const {
        data: {
          voteAllowed
        }
      } = await axios.get(`${process.env.VUE_APP_SLS_URL}/api/poll/${pollId}/whitelist-access`, {
        headers: {
          Authorization: `Bearer ${state.authorizationToken}`
        }
      });

      return voteAllowed;
    },
    async signup({ state, commit, rootState, dispatch }, {
      email,
      name,
      password,
      birthday,
      acceptTerms,
      zipCode,
      phoneNumber,
      optIns,
      accountName,
      loginWithoutPass,
      optIn
    }) {
      try {
        const {
          data: {
            authorization_token: authorizationToken,
            id: voterId,
            errorMessage
          }
        } = await axios.post(state.gamificationLinks.voterSignUp, {
          email,
          name,
          password,
          birthday,
          acceptTerms,
          zipCode,
          phoneNumber,
          optIns,
          accountName,
          loginWithoutPass,
          ...(optIn && {optIn})
        });
        if (errorMessage) {
          commit('setError', errorMessage);
          throw new Error(state.errorMessage);
        }
        dispatch('initAuthorizedState', {
          authorizationToken,
          voterId,
          name
        });
        //Clear votes from previus voter
        localStorage.removeItem('playToken');
        localStorage.removeItem('revisions');
      } catch (e) {
        Sentry.captureException(e);
        throw new Error(e);
      }
    },
    logout({ commit, state, dispatch }) {
      commit('setAuthorizationToken', null);
      commit('setEmail', null);
      commit('setAuthType', null);
      commit('setVoterId', null);
      commit('setName', '');
      commit('setAvatar', '');
      state.previousView = state.view;
      state.loginType === 'whitelist' ? commit('setView', 'unauthorized') : commit('setView', 'signup');
      commit('setAuthState', false);
      dispatch('pollGroup/reset', {}, { root: true });
      dispatch('pollGroup/clearPollGroupId', {}, { root: true });
      dispatch('poll/resetStateData', {}, { root: true });
    },
    async getGameSettings({ commit, state, dispatch }, pollGroupId) {
      try {
        const {
          data: {
            gamingPollGroups,
            leaderboardEnabled,
            scoring,
            gameLogo,
            isOptInEnabled,
            optInText
          }
        } = await axios.get(`${state.gamificationLinks.gameSettings}`, {
          params: {
            accountName: state.accountName,
            ...(pollGroupId && {pollGroupId: pollGroupId})
          }
        });
        commit('setGamePollGroupIds', gamingPollGroups);
        commit('setGameLogo', gameLogo);
        commit('setIsOptInEnabled', isOptInEnabled);
        commit('setOptInText', optInText);
      } catch (e) {
        throw new Error(e);
      }
    },
    async getVoterRank({ commit, state }) {
      const {
        data: rank
      } = await axios.get(`${process.env.VUE_APP_SLS_URL}/api/voter/rank`, {
        headers: {
          Authorization: state.authorizationToken
        },
        params: {
          accountName: state.accountName
        }
      });
      commit('setRank', rank);
    },
    async getAllPollGroups({ commit, state }, accountName) {
      const {
        data
      } = await axios.get(`${process.env.VUE_APP_SLS_URL}/api/pollGroup/active/${state.accountName}`);
      commit('setGamePollGroups', data);
      commit('setGamePollGroupIds', data.map(({ pollGroupId }) => pollGroupId))
    },
    async getPollGroup({ commit, state }, pollGroupId) {
      const {
        data
      } = await axios.get(`${process.env.VUE_APP_SLS_URL}/api/pollGroup/${pollGroupId}/settings`, {
        headers: {
          Authorization: state.authorizationToken
        }
      });
      return data;
    },
    setVoteId({ commit }, voteId) {
      commit('setVoteId', voteId);
    },
    async getVoterData({ commit, state, dispatch }, accountName) {
      try {
        const {
          data: {
            points,
            name,
            email,
            picture,
            voterId,
            accountName: accountNameLoggedInTo
          }
        } = await axios.get(state.gamificationLinks.voterInfo, {
          headers: {
            Authorization: state.authorizationToken
          }
        });
        if (accountName !== accountNameLoggedInTo) {
          throw new Error('This email can not access this account');
        }
        commit('setPoints', points);
        commit('setName', name);
        commit('setEmail', email);
        commit('setAvatar', picture);
        commit('setVoterId', voterId);
        commit('setAuthState', !!voterId);
      } catch (e) {
        if ((e.response || {}).status === 401) {
          return dispatch('logout');
        }
        throw new Error(e);
      }
    },
    async checkForValidSession({ state, dispatch }, accountName) {
      try {
        if (!state.authType ||
            !['email', 'social'].includes(state.authType) ||
            !state.authorizationToken ||
            !accountName)
          return false;
        await dispatch('getVoterData', accountName);
        return state.isAuthenticated;
      } catch (e) {
        throw new Error(e);
      }
    },
    async loadVoterSummary({ commit, state, dispatch }, pollGroupId) {
      try {
        const {
          data
        } = await axios.get(`${state.gamificationLinks.summaryInfo}/${pollGroupId}`, {
          headers: {
            Authorization: state.authorizationToken
          }
        });
        commit('setSummary', data);
        return data;
      } catch (e) {
        if ((e.response || {}).status === 401) {
          return dispatch('logout');
        }
        throw new Error(e);
      }
    },
    async getLeaderboard({ rootState }, { group, pageNumber = 1, limit = 100 }) {
      const { data } = await axios.get(`${process.env.VUE_APP_SLS_URL}/api/user/${rootState.poll.accountName}/leaderboard`, {
        params: {
          pageNumber,
          limit: group === 'bbl' ? 6 : limit
        }
      });
      return data;
    },
    async getLeaderBoardByPollGroup({ state }, { pollGroupId, limit = 10 }) {
      const { data } = await axios.get(
        `${process.env.VUE_APP_SLS_URL}/api/user/${state.accountName}/pollgroup/${pollGroupId}/leaderboard`,
        {
          params: {
            limit
          }
        }
      );
      return data;
    },
    async registerVote({ state, getters }, data) {
      if (!state.authorizationToken) return;

      // @todo: if we don't have a token, don't hit this endpoint
      try {
        await axios.post(`${state.gamificationLinks.userVote}${state.voteId}`, {...data, ...{
          startTime: state.startTime,
          endTime: Date.now(),
          period: state.showTimer ? state.period : undefined
        }}, {
          headers: {
            Authorization: state.authorizationToken
          }
        });
      } catch (err) {
        console.error(err);
      }
    },
    loadHashSettingsView({ commit, state}) {
      commit('setHashSettings');
      const {
        view
      } = state.hashSettings;
      view && commit('setView', view);
    },
    loadHashSettings({ commit, state}) {
      commit('setHashSettings');
      const {
        view,
        timer,
        period,
        startTime
      } = state.hashSettings;
      view && view !== state.view && commit('setView', view);
      timer && commit('setTimer', period);
      timer && commit('setPeriod', period);
      startTime && commit('setStartTime', startTime);
    },
    getExternalToken: ({ commit }) => {
      const params = new URLSearchParams(window.location.search);
      const externalToken = params.get('extToken') || '';
      commit('setExternalToken', externalToken);
    },
    getQueryToken({ commit }) {
      const params = new URLSearchParams(window.location.search);
      const queryToken = params.get('authorization_token');
      if (queryToken) {
        commit('setAuthorizationToken', queryToken);
        commit('setAuthType', 'social');
        return true;
      }
      return false;
    },
    getResetToken({ commit }) {
      const params = new URLSearchParams(window.location.search);
      const queryToken = params.get('resetToken');
      if (queryToken) {
        commit('setResetToken', queryToken);
        return true;
      }
      return false;
    },
    async setStartTimeStamp({ state }) {
      await axios.put(`${process.env.VUE_APP_SLS_URL}/api/poll/start`, {
        voteId: state.voteId
      }, {
        headers: {
          Authorization: state.authorizationToken
        }
      });
    }
  }
};
